import { ComponentRef, Injectable } from '@angular/core';
import {
  DialogCloseResult,
  DialogRef,
  DialogResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { EncounterAttendanceAbsentComponent } from '../components/encounter-attendance-absent/encounter-attendance-absent.component';

@Injectable({
  providedIn: 'root',
})
export class EncounterAttendanceAbsentDialogService {
  constructor(private dialogService: DialogService) {}

  public open(): {
    result$: Observable<DialogCloseResult | DialogResult>;
    instance: EncounterAttendanceAbsentComponent;
  } {
    const dialog: DialogRef = this.dialogService.open({
      content: EncounterAttendanceAbsentComponent,
      height: 'auto',
      maxHeight: '90vh',
      width: '530px',
      cssClass: 'encounter-attendance-absent',
    });

    const content: ComponentRef<EncounterAttendanceAbsentComponent> =
      dialog.content as ComponentRef<EncounterAttendanceAbsentComponent>;
    const instance: EncounterAttendanceAbsentComponent = content.instance;

    return {
      result$: dialog.result as Observable<DialogCloseResult | DialogResult>,
      instance,
    };
  }
}
